import {UseRootProperty} from "@/mixins/AuthorizationHelpers/UseRootProperty";

import _ from "lodash"

/**
 * Handle all matters related to actual page permissions
 * each async method should have a final parameter to force a recheck / reload.
 */
export class PermissionHelper extends UseRootProperty{
    constructor(mixin) {
        super(mixin, 'permissions', PermissionHelper.ROOT_KEY)
    }

    can(permission, company = null) {
        if (this._isNotReady()) {
            return false
        }

        company = this.mixin.currentCompanyIfNull(company)
        let permissions = this.getPermissions(company)

        if (permissions === undefined){
            return false
        }

        // Using the array of permissions check if the permission exists for this company.
        // TODO. In order to have this check on demand we will need to add some code here.
        return permissions.indexOf(permission) !== -1
    }

    getPermissions(company = null) {
        return this._getRootProperty(company)['permissions']
    }

    getPermissionLevelName(company = null) {
        return this._getRootProperty(company)['name']
    }

    isPermissionsLoaded(company = null) {
        let tmpPermissions = this.getPermissions(company);
        return !_.isNil(tmpPermissions) && tmpPermissions.length > 0;
    }

    isAdmin(company) {
        return this.can('edit_admin_permission',
                this.mixin.currentCompanyIfNull(company))
    }

    isSuperAdmin(company) {
        return this.can('edit_super_admin_permission',
                this.mixin.currentCompanyIfNull(company))
    }

    isSonicu(company = null) {
        return this.can('do_anything',
                this.mixin.currentCompanyIfNull(company))
    }

    isPartner(company = null) {
        return this.can('is_partner',
                this.mixin.currentCompanyIfNull(company))
    }

    isSonicuViewOnly(company = null) {
        return this.can('edit_sonicu_view_permission',
                this.mixin.currentCompanyIfNull(company))
    }
}

PermissionHelper.ROOT_KEY = 'permissions'